import { logger } from '../logger';
export function getStorage(lsKey) {
    try {
        var item = localStorage.getItem(lsKey);
        return JSON.parse(item || '');
    }
    catch (_a) {
        return null;
    }
}
export var verifyOptions = function (options) {
    if (typeof options !== 'object') {
        logger.error("Error loading Dreamdata script: 'intentSources' option must be an object but got ".concat(typeof options, ". This means there is likely an error in your script setup."));
        return false;
    }
    if (options === null) {
        logger.error('Failed to parse intent sources options due to a bug in our script. Please contact Dreamdata support.');
        return false;
    }
    if (Object.keys(options).length === 0) {
        logger.error("Error loading Dreamdata script: 'intentSources' cannot be empty if enabled. This means there is likely an error in your script setup.");
        return false;
    }
    return true;
};
export var getMatchingSources = function (sources, options) {
    var matchingSources = [];
    var _loop_1 = function (name_1, enabled) {
        if (!enabled) {
            return "continue";
        }
        var foundSource = sources.find(function (source) { return source.name === name_1; });
        if (foundSource) {
            matchingSources.push(foundSource);
        }
        else {
            logger.error("Unable to find intent source '".concat(name_1, "'. This means you have included an intent source in your script setup that is not recognized by Dreamdata."));
        }
    };
    for (var _i = 0, _a = Object.entries(options); _i < _a.length; _i++) {
        var _b = _a[_i], name_1 = _b[0], enabled = _b[1];
        _loop_1(name_1, enabled);
    }
    return matchingSources;
};
//# sourceMappingURL=utils.js.map